'use strict';

var $selectSizeModal = $('#selectProductSizeModal');
var carouselConfig = require('../components/carousel-config');
var afterpayWidget = require('../product/afterpayWidget');
var afterpayMobileContent = require('../product/afterpayContent');

/**
 * Fill Product Name
 */
function fillProductName() {
    var $displayColorName = $selectSizeModal.find('.color-name-desktop');
    var $mobileProductColorName = $selectSizeModal.find('.color-name-mobile');
    if ($displayColorName.length && $mobileProductColorName.length) {
        var selectedColor = $displayColorName.text();
        $mobileProductColorName.html(selectedColor);
    }
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseProductEditHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} selectedProductUrl - url to be used to retrieve a new product model
 */
function fillSelectSizeProductModal(selectedProductUrl) {
    const isQuickView = selectedProductUrl && selectedProductUrl.indexOf('Product-ShowQuickView') > -1;
    const method = isQuickView ? 'POST' : 'GET';

    $.spinner().start();
    $.ajax({
        url: selectedProductUrl,
        method: method,
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseProductEditHtml(data.renderedTemplate);

            $selectSizeModal.find('.modal-body').empty();
            $selectSizeModal.find('.modal-body').html(parsedHtml.body);
            $selectSizeModal.find('.modal-footer').html(parsedHtml.footer);
            $selectSizeModal.find('.modal-header .close .sr-only').text(data.closeButtonText);
            $selectSizeModal.find('.enter-message').text(data.enterDialogMessage);
            $selectSizeModal.modal('show');
            var productPrice;
            if (data.product.price.type === 'range') {
                productPrice = data.product.price.min.sales.value;
            }
            if (data.product.price.sales) {
                productPrice = data.product.price.sales.value;
            }
            afterpayWidget.getWidget(data.product.id, productPrice, 'pdp-afterpay-message');
            if (afterpayMobileContent && afterpayMobileContent.init && typeof afterpayMobileContent.init === 'function') {
                afterpayMobileContent.init();
            }
            fillProductName();
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Open Select Size modal
 * @param {Object} e event object
 */
function openSelectSizeModal(e) {
    e.preventDefault();
    $(document).trigger('shop-the-look:selectSize', $(this).attr('data-pid'));
    var selectedProductUrl = $(this).data('productQuickView');
    fillSelectSizeProductModal(selectedProductUrl);
}

/**
 * Handle events on carousel slide changes
 */
function handleCarouselControls() {
    carouselConfig.toggleCarouselControls($selectSizeModal);
}

/**
 * Fires when modal opens
 * @param {Object} e event object
 */
function onShowSelectSizeModal() {
    handleCarouselControls();
    $selectSizeModal.find('button.add-to-cart-global').removeAttr('disabled');
}

/**
 * Initialize event listeners for select size modal
 */
function initializeSelctSizeModalListeners() {
    if ($selectSizeModal.length) {
        // Listener needs to be global to be compatible with content that is added via AJAX.
        $(document).on('click', '.select-size-btn', openSelectSizeModal);

        $('body').on('slid.bs.carousel', '#selectProductSizeModal', handleCarouselControls);

        $(document).on('shown.bs.modal', '#selectProductSizeModal', onShowSelectSizeModal);

        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.modal.show .product-quickview .bundle-items').length) {
                $('.modal.show').find(response.container).data('pid', response.data.product.id);
                $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
            } else {
                $('.modal.show .product-quickview').data('pid', response.data.product.id);
            }
        });

        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            const disableAddToCart = response.product ? !response.product.available || response.product.hasSelectedUnorderableVariant : false;
            $('button.add-to-cart', response.$productContainer).attr('disabled', disableAddToCart);

            var enable = $('.product-availability', response.$productContainer).toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            $('button.add-to-cart-global', response.$productContainer).attr('disabled', !enable);
        });

        $('body').on('product:beforeAttributeSelect', function () {
            $selectSizeModal.find('.modal-body').spinner().start();
        });

        $('body').on('product:beforeAddToCart', function () {
            $selectSizeModal.find('.modal-content').spinner().start();
        });

        $('body').on('product:afterAddToCart', function () {
            $selectSizeModal.find('.modal-content').spinner().stop();
            $selectSizeModal.modal('hide');
        });
        import(/* webpackChunkName: "prod-base-chunk" */ '../product/base').then(function (productBase) {
            productBase.selectAttribute();
            productBase.colorAttribute();
            productBase.addToCart();
        });
    }
}

$(document).ready(function () {
    initializeSelctSizeModalListeners();
});
